import classNames from 'classnames';
import { CSSProperties } from 'react';
import { RegisterOptions } from 'react-hook-form';
import styles from 'styles/components/common/forms/Checkbox.module.scss';
import FormCheckboxInput from './FormCheckboxInput';

type TProps = {
  id?: string;
  name: string;
  rule?: RegisterOptions;
  text?: string;
  value?: string | number;
  formCheckboxStyle?: CSSProperties;
  labelStyle?: CSSProperties;
  inputStyle?: CSSProperties;
  customInputStyle?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  afterChange?: (value: string | number | boolean | string[]) => void;
  onClick?: () => void;
  multiple?: boolean;
  checked?: boolean;
};

const FormCheckbox = (props: TProps) => {
  const {
    text,
    formCheckboxStyle,
    labelStyle,
    disabled,
    readOnly,
    customInputStyle,
    onClick,
  } = props;
  const className = classNames(styles.checkbox, {
    [styles.disabled_checkbox]: disabled,
    [styles.custom_input]: customInputStyle,
  });
  return (
    <div style={formCheckboxStyle} className="inline_flex">
      <div className={classNames(styles.checkbox_inline)} onClick={onClick}>
        <label
          className={classNames(styles.label, {
            [styles.disabled_label]: disabled,
            [styles.readonly_label]: readOnly,
          })}
          style={labelStyle}
        >
          <FormCheckboxInput {...props} className={className} />
          {text}
        </label>
      </div>
    </div>
  );
};

export default FormCheckbox;
